import React, { useMemo, useCallback } from "react";
import "../styles/brands.css";
import { config } from "./config";
import { useFetch } from "./fetch";
import { useNavigate } from "react-router-dom";
import LoaderComponent from "./loaderComponent";
import { motion } from "framer-motion";

const Brands = React.memo(() => {
  const navigate = useNavigate();
  const today = useMemo(() => new Date(), []); // Memoize today’s date

  const isNew = useCallback((createdDate) => {
    const created = new Date(createdDate);
    const diffTime = today - created;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays <= 7;
  }, [today]);

  // API call using useFetch
  const { data, error, isLoading } = useFetch(`api/brands`, config.serverURL);

  if (isLoading)
    return (
      <div className="d-flex justify-center align-center">
        <LoaderComponent />
      </div>
    );
  
  if (error) return <div>Error loading brands: {error.message}</div>;

  return (
    <motion.div
      className="categories-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }} // Fade-in animation for the whole container
    >
      {data?.map((brand) => (
        <motion.div
          key={brand._id}
          className="category text-cap"
          onClick={() => navigate(`/brand/${brand.name}`)} // Optimized navigation function
          initial={{ x: "-100vw", opacity: 0 }} // Start from left (offscreen)
          animate={{ x: 0, opacity: 1 }} // Animate to final position
          transition={{
            duration: 1,
            delay: 0.1, // Stagger animation for each item
            ease: "easeOut",
          }}
          style={{ backgroundColor: brand.imageUrl ? "transparent" : "#f0f0f0" }}
        >
          {brand.imageUrl ? (
            <img src={brand.imageUrl} alt={brand.name} className="w-100 h-100 object-contain p-0" />
          ) : (
            brand.name
          )}
          {isNew(brand.created) && (
            <span
              className="pos-absolute bg-white br-4 b-1 br-16 p-025 fs-0-5 border-primary"
              style={{
                top: "-5px",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              New
            </span>
          )}
        </motion.div>
      ))}
    </motion.div>
  );
});

export default Brands;
